$(document).on('click', '.change-course-selection', function(e) {
  e.preventDefault()

  var courseId = $(this).attr('data-course')
  var hiddenField = $(this).attr('data-field')

  $('.selected').hide()
  $('.notSelected').show()

  $('.card[data-value="' + courseId + '"]').find('.notSelected').hide()
  $('.card[data-value="' + courseId + '"]').find('.selected').show()

  $('#' + hiddenField).val(courseId).trigger('change')
})
